import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Reserve from './pages/Reserve';
import Login from './pages/Login';
import Profile from './pages/Profile';
import AdminLayout from './pages/admin/AdminLayout';
import AdminCalendar from './pages/admin/AdminCalendar';
import AdminClients from './pages/admin/AdminClients';
import AdminClasses from './pages/admin/AdminClasses';
import AdminBonus from './pages/admin/AdminBonus';
import AdminReservas from './pages/admin/AdminReservas';
import AdminBonusTypes from './pages/admin/AdminBonusTypes';
import AdminNotifications from './pages/admin/AdminNotifications';
import AdminProfileClasses from './pages/admin/AdminProfileClases';
import AdminConfig from './pages/admin/AdminConfig';
import AdminTrialRequests from './pages/admin/AdminTrialRequests';
import AdminServices from './pages/admin/AdminServices';
import UpdatePassword from './pages/UpdatePassword.jsx';


function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/reserve" element={<Reserve />} />
      <Route path="/login" element={<Login />} />
      <Route path="/profile" element={<Profile />} />
      <Route path="/update-password" element={<UpdatePassword />} />
      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<AdminCalendar />} />
        <Route path="calendar" element={<AdminCalendar />} />
        <Route path="clients" element={<AdminClients />} />
        <Route path="classes" element={<AdminClasses />} />
        <Route path="bonus-types" element={<AdminBonusTypes />} />
        <Route path="bonus/:clientId/:clientName" element={<AdminBonus />} />
        <Route path="profileclasses/:clientId/:clientName" element={<AdminProfileClasses />} />
        <Route path="reservations/:id" element={<AdminReservas />} />
        <Route path="notifications" element={<AdminNotifications />} />
        <Route path="trial-requests" element={<AdminTrialRequests />} />
        <Route path="config" element={<AdminConfig />} />
        <Route path="services" element={<AdminServices />} />
      </Route>
    </Routes>
  );
}



export default App;